module.exports = __webpack_public_path__ + "img/coins.92114c55.gif";